import 'bootstrap/dist/css/bootstrap.min.css';
import 'font-awesome/css/font-awesome.css';
import 'magnific-popup/dist/magnific-popup.css';

import '../less/index.less';

import $ from 'jquery';
import 'bootstrap';

import 'jquery-validation';
import 'jquery-validation/dist/localization/messages_ru';

import 'jquery-form';

import 'magnific-popup';
import './common/magnific_popup_translate';
import './common/scroll';

import {goAjaxForm} from './common/ajax-form';
import {scrollToHash} from './common/scroll';


const feedback = () => {
    const $form = $('#feedback-form');
    if ($form.length) {
        $form.validate();
        goAjaxForm({form_id: '#feedback-form'});
    }
};

$(function () {
    // mobilemenu
    const $mm = $('.mobile-menu');
    $('.bars').click(function () {
        $mm.slideToggle();
    });
    $mm.click(function () {
        $mm.hide();
    });

    // sticky menu & submenu
    const $topmenu = $('.topmenu');
    const $submenu = $('.submenu');
    const top = $topmenu.offset().top;

    const s_top = $topmenu.outerHeight() + 40;
    const s_width = $submenu.outerWidth();
    const bottom = $('.js-bottom-slider').offset().top - $submenu.outerHeight() - s_top - 30;

    $(window).scroll(function () {
        const scroll_position = $(window).scrollTop();
        if (scroll_position >= top) {
            $topmenu.addClass('fixed-menu');
            $submenu.addClass('fixed-submenu');
            $submenu.css('top', s_top);
            $submenu.css('width', s_width);
            $('body').addClass('fixed-menu-body');

            if (scroll_position > bottom) {
                $submenu.removeClass('fixed-submenu');
                $submenu.addClass('absolute-submenu');
            } else {
                $submenu.addClass('fixed-submenu');
                $submenu.removeClass('absolute-submenu');
            }
        } else {
            $submenu.removeClass('absolute-submenu');
            $topmenu.removeClass('fixed-menu');
            $submenu.removeClass('fixed-submenu');
            $('body').removeClass('fixed-menu-body');
        }
    });

    //gallery
    const $gal = $('.js-gallery');
    if ($gal.length) {
        $('.js-gallery').magnificPopup({
            type: 'image',
            gallery: {enabled: true},
        });
    }
    //forms
    feedback();


    // Scroll
    if (window.location.hash !== '') {
        window.setTimeout(
            scrollToHash(window.location.hash), 2000
        );
    }
    $('.js-st').click(function (e) {
        e.preventDefault();
        scrollToHash('#' + $(this).attr('href').split('#')[1]);
    });

    $(window).scroll(function () {
        const top = $(this).scrollTop();
        const $go_top = $('.go-top');
        if (top > 150) {
            $go_top.fadeIn('slow');
        } else {
            $go_top.fadeOut('slow');
        }
    });

});



// WEBPACK FOOTER //
// ./js/index.js